import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Translate"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M20.8874 21.75H22.4999L17.9999 10.5H16.2374L11.7374 21.75H13.3499L14.5499 18.75H19.6874L20.8874 21.75ZM15.15 17.25L17.115 12.33L19.0875 17.25H15.15ZM13.5 5.25V3.75H8.25V1.5H6.75V3.75H1.5V5.25H9.555C9.13944 6.96403 8.31902 8.55345 7.1625 9.885C6.4086 8.95013 5.82704 7.88859 5.445 6.75H3.87C4.34211 8.27746 5.10624 9.69875 6.12 10.935C4.99958 12.0218 3.68742 12.8915 2.25 13.5L2.8125 14.895C4.42768 14.213 5.89873 13.2306 7.1475 12C8.37362 13.2475 9.8444 14.228 11.4675 14.88L12 13.5C10.5543 12.9412 9.24497 12.0794 8.16 10.9725C9.59593 9.33597 10.6058 7.37035 11.1 5.25H13.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Translate.vue"]]);
